var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6233 13.1169C39.8843 12.8237 38.7122 12.5 37.2629 12.5C33.563 12.5 30.9576 14.473 30.9416 17.2937C30.9109 19.3748 32.807 20.5307 34.2252 21.2247C35.6747 21.9337 36.1674 22.3966 36.1674 23.0286C36.1527 23.9993 34.9962 24.4468 33.9175 24.4468C32.4217 24.4468 31.6202 24.2161 30.4022 23.676L29.9089 23.4445L29.3846 26.6971C30.2633 27.0974 31.8822 27.4527 33.563 27.4683C37.4942 27.4683 40.0535 25.5258 40.0839 22.5199C40.0988 20.8704 39.0976 19.6065 36.939 18.5738C35.6286 17.9108 34.8261 17.4637 34.8261 16.7854C34.8415 16.1687 35.5049 15.5371 36.9841 15.5371C38.2021 15.5062 39.097 15.7989 39.7749 16.0919L40.1138 16.2458L40.6233 13.1169Z",
    fill: "#1F86FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0416 27.2523H23.295L25.6384 12.7627H29.3848L27.0416 27.2523Z",
    fill: "#1F86FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2275 12.7627H47.3295C46.4358 12.7627 45.7569 13.0245 45.3713 13.9649L39.8062 27.2521H43.7374C43.7374 27.2521 44.3846 25.4638 44.5237 25.0786H49.334C49.4415 25.5873 49.781 27.2521 49.781 27.2521H53.25L50.2275 12.7627ZM45.6028 22.1191C45.9113 21.2867 47.0986 18.0651 47.0986 18.0651C47.0923 18.0775 47.1406 17.9436 47.2126 17.744L47.2135 17.7416L47.2141 17.74C47.3216 17.4418 47.4813 16.9993 47.5915 16.6778L47.8534 17.9264C47.8534 17.9264 48.5628 21.3947 48.7169 22.1191H45.6028Z",
    fill: "#1F86FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1658 12.7627L16.4966 22.6432L16.0957 20.6393L16.0953 20.6381L14.7853 13.9806C14.5696 13.0552 13.9066 12.7932 13.0895 12.7627H7.06167L7 13.0554C8.47018 13.4314 9.78511 13.9731 10.9373 14.6467L14.2766 27.237H18.2385L24.1275 12.7627H20.1658Z",
    fill: "#1F86FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.1f89e1f7b3aa087ebe45aa2b0a95a71e.svg";
export { ForwardRef as ReactComponent };